<template>
  <div class="my-file">
    <span class="btn btn-sm btn-primary" @click="trigger">上传附件</span>
    <input type="file" ref="file" @change="getVal" hidden>
    <span v-show="filename">{{filename}}</span>
    <span class="text-primary del" @click="reset" v-show="filename">×</span>
  </div>
</template>

<script>
export default {
  name: "myFile",
  props: ['value'],
  computed: {
    filename() {
      return this.value && this.value.name;
    }
  },
  watch: {
    value (val) {
      if (!val) {
        this.reset();
      }
    }
  },
  methods: {
    trigger () {
      this.$refs.file.click();
    },
    getVal (e) {
      var file = e.target.files[0];
      this.$emit('input', file);
      this.$emit('change', file);
    },
    reset () {
      this.$refs.file.value = null;
      this.$emit('input', '');
    }
  }
}
</script>

<style scoped>
  .my-file {
    display: inline-block;
  }
  .del {
    font-size: 18px;
    display: inline-block;
    margin-left: 10px;
    cursor: default;
    vertical-align: -2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/file.vue